@if (batchPostingFileSummaryDto) {
  <div class="container">
    <h1>{{uploadInServiceVehicleFileDetailsTranslations.header}}</h1>
    <div class="file-name-label">
      {{getFileInfo()}}
    </div>
    <app-datalist-item
      [label]="uploadInServiceVehicleFileDetailsTranslations.vehiclesInFile"
      value="{{batchPostingFileSummaryDto.vehiclesInFile}}"
    ></app-datalist-item>
    <app-datalist-item
      [label]="uploadInServiceVehicleFileDetailsTranslations.errors"
      value="{{batchPostingFileSummaryDto.errors}}"
    ></app-datalist-item>
    <app-datalist-item
      [label]="uploadInServiceVehicleFileDetailsTranslations.newVehiclesAdded"
      value="{{batchPostingFileSummaryDto.newVehiclesAdded}}"
    ></app-datalist-item>
    <app-datalist-item
      [label]="uploadInServiceVehicleFileDetailsTranslations.updatedVehicles"
      value="{{batchPostingFileSummaryDto.updatedVehicles}}"
    ></app-datalist-item>
    <app-datalist-item
      [label]="uploadInServiceVehicleFileDetailsTranslations.vehiclesRemoved"
      value="{{batchPostingFileSummaryDto.vehiclesRemoved}}"
    ></app-datalist-item>
    @if (!downloading) {
      <button
        class="btn btn-primary"
        type="submit"
        (click)="downloadClicked()"
        >
        {{uploadInServiceVehicleFileDetailsTranslations.downloadText}}
      </button>
    } @else {
      <app-spinner></app-spinner>
    }
  </div>
}
